import React, { Component } from "react";
import clsx from "clsx";

import "./tools-stat-card.css";

class ToolsStatCard extends Component {
	render() {
		const { icon, tone = "neutral", label, value, delta, deltaTone = "neutral", isActive, isEmpty, onClick, title } = this.props;
		const className = clsx(
			"tools-stat-card",
			`tools-stat-card--${tone}`,
			isActive && "tools-stat-card--active",
			isEmpty && "tools-stat-card--empty",
			onClick && "tools-stat-card--clickable"
		);
		const body = (
			<React.Fragment>
				<span className="tools-stat-card__head">
					<span className={`tk-icon-tile tk-icon-tile--sm tk-icon-tile--${tone}`}>{icon}</span>
					<span className="tools-stat-card__label">{label}</span>
				</span>
				<span className="tools-stat-card__value">{value === null || value === undefined ? "–" : value}</span>
				{delta && <span className={`tools-stat-card__delta tools-stat-card__delta--${deltaTone}`}>{delta}</span>}
			</React.Fragment>
		);

		if (!onClick) {
			return (
				<div className={className} title={title}>
					{body}
				</div>
			);
		}

		return (
			<button type="button" className={className} onClick={onClick} aria-pressed={!!isActive} title={title}>
				{body}
			</button>
		);
	}
}

export default ToolsStatCard;
